/**
 * Levina Drapakoszyk™ — POPUP UPSELL „poduszka” po kliknięciu „Dodaj do koszyka” (strona produktu)
 * ================================================================================================
 * Markup, teksty i style: sections/levina-kosz-upsell-popup.liquid (sekcja statyczna w layout/theme.liquid).
 *
 * CO ROBI
 *   1. Klik w „Dodaj do koszyka” pickera (snippets/levina-kosz-bundle.liquid, przycisk [data-lkb-atc]) jest przechwytywany
 *      w fazie capture na document — oryginalna obsługa (dodanie Drapakoszyka + otwarcie drawera) NIE rusza.
 *   2. Pokazuje się popup z poduszką (zawsze, bez cookies; animacja wyskoku ze środka).
 *   3. „Dodaj do koszyka” w popupie: POST /cart/add.js z poduszką (ilość z popupu) → dopiero potem oryginalny klik
 *      w „Dodaj do koszyka” pickera (flaga bypass), więc drawer renderuje się z OBOMA produktami jednym natywnym przepływem.
 *      Błąd dodania poduszki nigdy nie blokuje zakupu Drapakoszyka (po 8 s timeoutu lub błędzie i tak przepuszczamy klik).
 *   4. „Nie, dziękuję”, X, kliknięcie w tło i Esc: zamyka popup i przepuszcza oryginalny klik (tylko wybrany Drapakoszyk).
 *
 * ODPORNOŚĆ
 *   - Bez sekcji w DOM (inna strona, produkt niedostępny, wyłączone w ustawieniach) skrypt nic nie przechwytuje.
 *   - W edytorze motywu (Shopify.designMode) skrypt się nie uruchamia.
 *   - Przycisk z atrybutem disabled (picker blokuje go, gdy zestaw jest niedostępny) nie otwiera popupu.
 *   - Każde dodanie e-booka i rabat ilościowy działają jak dotąd: levina-kosz-ebook-sync.js obserwuje fetch do /cart/add.
 */
(function () {
  'use strict';

  if (window.__levinaUpsell) return;
  window.__levinaUpsell = true;
  try { if (window.Shopify && window.Shopify.designMode) return; } catch (e) { /* ignoruj */ }

  var TRIGGER = '[data-lkb-atc]';
  var ADD_TIMEOUT_MS = 8000;
  var CLOSE_MS = 150;
  var QTY_MAX = 10;

  var bypass = false;      /* true tylko na czas syntetycznego kliknięcia, które ma przejść do oryginalnej obsługi */
  var busy = false;        /* trwa dodawanie poduszki / zamykanie — ignorujemy kolejne klikniecia */
  var isOpen = false;
  var pendingBtn = null;   /* przycisk pickera, który wstrzymaliśmy */
  var lastFocus = null;
  var closeTimer = null;
  var root = null;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function routeRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (typeof r === 'string' && r) ? r : '/';
  }

  /* ---------- klik w „Dodaj do koszyka” pickera ---------- */
  document.addEventListener('click', function (e) {
    if (bypass || isOpen || busy) {
      /* popup otwarty / zajęty: klik w przycisk pickera pod spodem nie ma prawa dojść do oryginalnej obsługi */
      if (!bypass && e.target && e.target.closest && e.target.closest(TRIGGER)) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(TRIGGER);
    if (!btn || btn.disabled) return;
    var el = document.getElementById('levina-upsell');
    if (!el || el.getAttribute('data-ready') !== 'true') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(el, btn);
  }, true);

  /* ---------- otwieranie / zamykanie ---------- */
  function open(el, btn) {
    try {
      if (el.parentNode !== document.body) document.body.appendChild(el);   /* poza wrapperem sekcji — czysty stacking context */
      root = el;
      bindOnce();
      pendingBtn = btn;
      lastFocus = document.activeElement;
      resetUI();
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      root.classList.remove('is-closing');
      root.hidden = false;
      root.classList.add('is-open');
      document.documentElement.classList.add('lku-lock');
      isOpen = true;
      var dlg = $('[data-lku-scroll]');   /* fokus na przewijanym oknie (nie na przycisku): bez ramki na „Dodaj do koszyka”, a strzałki/PageDown przewijają kartę */
      if (dlg) { try { dlg.focus({ preventScroll: true }); } catch (e) { dlg.focus(); } }
    } catch (err) {
      /* jakikolwiek błąd UI nie może zablokować zakupu */
      isOpen = false;
      document.documentElement.classList.remove('lku-lock');
      proceed(btn);
    }
  }

  function closeUI() {
    if (!root) return;
    isOpen = false;
    document.documentElement.classList.remove('lku-lock');
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    closeTimer = setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-closing');
      closeTimer = null;
    }, CLOSE_MS);
    if (lastFocus && lastFocus.focus && lastFocus.isConnected) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignoruj */ } }
  }

  /* przepuszcza oryginalne dodanie Drapakoszyka (obsługa pickera) */
  function proceed(btn) {
    var target = btn && btn.isConnected ? btn : document.querySelector(TRIGGER);
    if (!target || target.disabled) return;
    bypass = true;
    try { target.click(); } finally { bypass = false; }
  }

  function setBusyUI(on, label) {
    $$('[data-lku-add], [data-lku-no], .lku__x').forEach(function (b) { b.disabled = !!on; });
    var add = $('[data-lku-add]');
    if (add) add.textContent = on ? (label || add.textContent) : (root.getAttribute('data-add-label') || add.textContent);
  }

  function decline() {
    if (busy || !isOpen) return;
    busy = true;
    var btn = pendingBtn;
    closeUI();
    proceed(btn);
    pendingBtn = null;
    busy = false;
  }

  function accept() {
    if (busy || !isOpen) return;
    busy = true;
    var btn = pendingBtn;
    setBusyUI(true, root.getAttribute('data-adding-label') || 'Dodaję…');
    addUpsell().then(function () {
      setBusyUI(false);
      closeUI();
      proceed(btn);
      pendingBtn = null;
      busy = false;
    });
  }

  /* ---------- dodanie poduszki do koszyka ---------- */
  function currentVariantId() {
    var sel = $('[data-lku-variant]');
    return Number((sel && sel.value) || root.getAttribute('data-variant-id')) || 0;
  }
  function currentQty() {
    var inp = $('[data-lku-qinput]');
    var n = parseInt(inp && inp.value, 10);
    if (!n || n < 1) n = 1;
    return Math.min(n, QTY_MAX);
  }

  function addUpsell() {
    var id = currentVariantId();
    if (!id || typeof window.fetch !== 'function') return Promise.resolve(false);
    var ctrl = null, tm = null, opts;
    opts = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: currentQty() }] })
    };
    try {
      if (window.AbortController) {
        ctrl = new AbortController();
        opts.signal = ctrl.signal;
        tm = setTimeout(function () { try { ctrl.abort(); } catch (e) { /* ignoruj */ } }, ADD_TIMEOUT_MS);
      }
    } catch (e) { ctrl = null; }
    return fetch(routeRoot() + 'cart/add.js', opts).then(function (res) {
      if (tm) clearTimeout(tm);
      return !!res.ok;
    }, function () {
      if (tm) clearTimeout(tm);
      return false;
    });
  }

  /* ---------- UI: zdjęcia, ilość, wariant ---------- */
  function resetUI() {
    var inp = $('[data-lku-qinput]');
    if (inp) inp.value = '1';
    setBusyUI(false);
    var track = $('[data-lku-track]');
    if (track) track.scrollLeft = 0;
    var sc = $('[data-lku-scroll]');
    if (sc) sc.scrollTop = 0;    /* karta zawsze otwiera się od góry */
    markGallery(0);
  }

  function slideCount() { var tr = $('[data-lku-track]'); return tr ? tr.children.length : 0; }

  function markGallery(i) {
    var n = slideCount();
    $$('[data-lku-thumb]').forEach(function (th, k) { th.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var prev = $('[data-lku-prev]'), next = $('[data-lku-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }

  function goTo(i) {
    var tr = $('[data-lku-track]');
    if (!tr) return;
    var n = slideCount();
    i = Math.max(0, Math.min(n - 1, i));
    var behavior = 'smooth';
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'auto'; } catch (e) { /* ignoruj */ }
    try { tr.scrollTo({ left: i * tr.clientWidth, behavior: behavior }); } catch (e) { tr.scrollLeft = i * tr.clientWidth; }
    markGallery(i);
  }

  function currentIndex() {
    var tr = $('[data-lku-track]');
    return tr && tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0;
  }

  function focusables() {
    return $$('button:not([disabled]), input:not([disabled]), select:not([disabled]), [href]').filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  var bound = false;
  function bindOnce() {
    if (bound) return;
    bound = true;

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-lku-add]')) { accept(); return; }
      if (t.closest('[data-lku-no]')) { decline(); return; }
      var th = t.closest('[data-lku-thumb]');
      if (th) { goTo(parseInt(th.getAttribute('data-lku-thumb'), 10) || 0); return; }
      if (t.closest('[data-lku-prev]')) { goTo(currentIndex() - 1); return; }
      if (t.closest('[data-lku-next]')) { goTo(currentIndex() + 1); return; }
      var q = t.closest('[data-lku-q]');
      if (q) {
        var inp = $('[data-lku-qinput]');
        var n = (parseInt(inp.value, 10) || 1) + (parseInt(q.getAttribute('data-lku-q'), 10) || 0);
        inp.value = String(Math.max(1, Math.min(QTY_MAX, n)));
      }
    });

    var qin = $('[data-lku-qinput]');
    if (qin) {
      qin.addEventListener('change', function () {
        var n = parseInt(qin.value, 10);
        qin.value = String(!n || n < 1 ? 1 : Math.min(n, QTY_MAX));
      });
    }

    var tr = $('[data-lku-track]');
    if (tr) {
      var wait = null;
      tr.addEventListener('scroll', function () {
        if (wait) clearTimeout(wait);
        wait = setTimeout(function () { markGallery(currentIndex()); }, 80);
      }, { passive: true });
    }

    var sel = $('[data-lku-variant]');
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var now = $('[data-lku-now]'), cmp = $('[data-lku-cmp]'), pct = $('[data-lku-pct]');
        if (now) now.textContent = opt.getAttribute('data-now') || '';
        var c = opt.getAttribute('data-cmp') || '';
        if (cmp) { cmp.textContent = c; cmp.hidden = !c; }
        if (pct) pct.hidden = !c;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); decline(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      var onDialog = document.activeElement === $('[data-lku-scroll]');
      if (e.shiftKey && (onDialog || document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
  }

  /* bfcache: po powrocie do strony popup nie może zostać otwarty */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted && root) {
      isOpen = false; busy = false; pendingBtn = null;
      root.hidden = true;
      root.classList.remove('is-open', 'is-closing');
      document.documentElement.classList.remove('lku-lock');
    }
  });

  /* diagnostyka z konsoli: LevinaUpsell.isOpen() */
  window.LevinaUpsell = { isOpen: function () { return isOpen; } };
})();
